const calculator = ({ num1 = 0, num2 = 0, operator = "" }) => {
  const cleanNum = (num) => Number(num?.toString().replace(/,/g, ""));
  const cleanNum1 = typeof num1 !== "number" ? cleanNum(num1) : num1;
  const cleanNum2 = typeof num2 !== "number" ? cleanNum(num2) : num2;

  switch (operator) {
    case "+":
      return cleanNum1 + cleanNum2;
    case "-":
      return cleanNum1 - cleanNum2;
    case "*":
      return cleanNum1 * cleanNum2;
    case "/":
      return cleanNum2 !== 0
        ? cleanNum1 / cleanNum2
        : "Error: Division by zero";
    default:
      return "Error: Invalid operator";
  }
};

export { calculator };
